import React, {useState} from "react";
import {tagsSystem} from "utils";
import {SelectTags} from "components/Select";
import {useTags} from "store/providers/tags";
import {setIndicator} from "services/Indicators.service";
import {toast} from "react-toastify";

export const TagsListEdit = ({indicatorId, tagsIndicator, lang}) => {

    const [tags, setTags] = useState(tagsIndicator)
    const { tagListLang, tagsListEn } = useTags()

    function changeArray(data) {
        if(data && data.length){
            return data.map(i => ({ value: i.id, label: i.name }))
        }
    }

    function changeTags(data) {
        return data.map(tag => ({
            id: tag.value,
            name: tag.label
        }))
    }

    const handleChange = async (newValue, actionMeta, name) => {
        const newTags = {...tags}
        newTags[name] = changeTags(newValue)

        setTags(newTags)

        await setIndicator(indicatorId, {tags: newTags})
            .then(() => {
                switch (actionMeta.action) {
                    case 'remove-value':
                        return toast.success('Tag removida com sucesso!')
                    case 'clear':
                        {
                            const labelTag = tagsSystem.find(tag => tag.value === name);
                            return toast.success(`Todas as tags de ${labelTag.label} foram removidas!`)
                        }
                    case 'select-option':
                        toast.success('Tag adicionada com sucesso')
                }
            })
            .catch(() => toast.error('Erro ao adicionar tag'))
    }

    return (
        <div className="row mx-0">
            {tagsSystem.map((tag) => {
                const selectedTags = changeArray(tagsIndicator[tag.value])
                return (
                <div className="col-12 col-md-6 col-xl-4" key={tag.value}>
                    <div className="form-group mt-2">
                        <label className="form-label">{tag.label}</label>
                        <SelectTags
                            items={lang === 'en-US' ? tagsListEn[tag.value] : tagListLang[tag.value]}
                            lang={lang}
                            selected={selectedTags}
                            handleChange={(newValue, actionMeta) => handleChange(newValue, actionMeta, tag.value)}
                            name={tag.value}
                        />
                    </div>
                </div>
            )})}
        </div>
    )
}